import Marionette from "backbone.marionette";

import InsertCompany from "views/companies/insertCompanyView.js";
import CompanyModel from "models/companyModel.js";
import CompaniesTpl from "views/companies/companiesView.ejs";
import CSS from "views/companies/companies.css";

import S from "session/session.js";
import T from "session/token.js";

require('jquery-equalheights');

export default Marionette.View.extend({
    initialize: function() {

        $('.content-wrapper').css({ 'margin-left': '230px' });


        this.listenTo(S.mApp, "update:companies", function(ev) {
            this.collection.fetch({
                beforeSend: T.useToken
            });
        });

        this.listenTo(this.collection, "destroy", this.applyView.bind(this));
        this.listenTo(this.collection, "add:companies", this.applyView.bind(this));
        this.listenTo(this.collection, "sync", this.applyView.bind(this));
    },
    template: CompaniesTpl,
    render: function() {
        this.collection.fetch({
            beforeSend: T.useToken
        });

        S.userInfo.set({
            options: S.mainMenu
        });

    },
    applyView: function() {
        this.$el.html(this.template({
            models: this.collection.models,
            lang: this.collection.lang,
            role: S.userInfo.attributes.role
        }));


        $("body").removeClass().addClass("hold-transition skin-black fixed sidebar-mini");
        $(".main-sidebar").show();

        // Hide usuarios y entornos
        $("a#USERS, a#ENVIRO").parent().hide();

        // Remove active menu items
        $(".sidebar li").removeClass("active");
        $(".sidebar li > ul").removeClass("menu-open");
        // Add active menu items
        $("#COMPANIES").parent().addClass("active");

    },
    events: {
        "click .company": "selectCompany",
        "click #addCompany": "addCompany",
        "click .editCompany": "editCompany"
    },
    selectCompany: function(ev) {
        var tag = $(ev.currentTarget);
        S.companyId = tag.attr("data-id");

        //Show usuarios e instancias
        $("#option2, #option3").show();

        window.top.location = "#enviro";
    },
    addCompany: function(ev) {
        S.mApp.trigger("modal", {
            view: new InsertCompany({
                model: new CompanyModel(),
                collection: this.collection
            })
        });
    },
    editCompany: function(ev) {
        var tag = $(ev.currentTarget);
        S.mApp.trigger("modal", {
            view: new InsertCompany({
                model: this.collection.get(tag.attr("data-id")),
                collection: this.collection
            })
        })
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/views/companies/companiesView.js
// module id = 179
// module chunks = 0